var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full py-1 px-2 text-xs font-medium inline-flex items-center",class:{
    'text-mountainMeadow bg-iceberg': _vm.normalizedState === 'verified',
    'text-black bg-brightSun': _vm.normalizedState === 'in_review',
    'text-persimmon bg-pippin': _vm.normalizedState === 'denied',
    'bg-white': !_vm.normalizedState,
  }},[(_vm.normalizedIcon)?_c('HiboSvg',{attrs:{"svg":_vm.normalizedIcon,"svg-class":"mr-1 h-15"}}):_vm._e(),_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.normalizedText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }